import React from 'react';
import SEO from './SEO';
import PlaylistViewer from './PlaylistViewer';

const messagePlaylists = [
  {
    title: 'Bible Book Highlights - English',
    id: 'PLlfpe0DDwzp1jmVFvCvEbpY7LOgQOdMYv',
    description: 'Enjoy the Bible Book Highlights - English.',
  },
  {
    title: 'Kids Bible Books Highlights (English)',
    id: 'PLlfpe0DDwzp1lPf404tiN5cGQnv_RPwaQ',
    description: 'Enjoy the Kids Bible Books Highlights (English).',
  },
  {
    title: 'Romans English Bible Message',
    id: 'PLlfpe0DDwzp3Rk9X-AWDNF9nbvYYnqsoY',
    description: 'Enjoy the English Bible Messages.',
  },
  {
    title: 'Tamil Bible Message',
    id: 'PLlfpe0DDwzp1V1_PA3yB04A-AHAJ55hfn',
    description: 'Top trending Tamil Bible Messages.',
  },
  {
    title: 'Bible Chapter Summary in 3 Minutes - English',
    id: 'PLlfpe0DDwzp2JTpFvINtyMI1307E83Wa1',
    description: 'A collection of Bible Chapter Summaries in 3 Minutes.',
  },
  {
    title: 'Kids Bible Chapter Highlights',
    id: 'PLlfpe0DDwzp3wxJwEfF6bnH8m2VReVs-y',
    description: 'A collection of Kids Bible Highlights.',
  },
  {
    title: 'Holy Reels - English Bible',
    id: 'PLlfpe0DDwzp0qyYeMRgfawc-JSarbF05P',
    description: 'A collection of visual Bible highlights.',
  },
  {
    title: 'Spiritual Guidance & Bible Stories',
    id: 'PLlfpe0DDwzp1B7MLw39wOhpBcZzkbum4U',
    description: 'A collection of Spiritual Guidance & Bible Stories.',
  },
  {
    title: 'Prayers & Spiritual Wisdom',
    id: 'PLlfpe0DDwzp0JVlMGCrz1GILAWjl-TQjI',
    description: 'A collection of Prayers & Spiritual Wisdom.',
  },
  {
    title: 'Malayalam Bible Message',
    id: 'PLlfpe0DDwzp1-FZLlJ8pt4IOM87D8fBdC',
    description: 'A collection of Malayalam Bible Messages.',
  },
];

export default function Messages() {
  return (
    <>
      <SEO
        title="Messages"
        description="Curated Bible teachings and devotionals."
      />
      <PlaylistViewer
        pageTitle="Messages"
        playlists={messagePlaylists}
        showPageTitle={false}
      />
    </>
  );
}
